<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import DecreaseIncreaseInput from 'src/components/DecreaseIncreaseInput.svelte';
	import { MAX_TEMPERATURE_LIMIT, MIN_TEMPERATURE_LIMIT } from 'src/constants';

	export let minTemp,
		maxTemp,
		deftemp,
		mode: string = 'heat',
		unit: string = 'F';

	let minError,
		maxError,
		cacheMode = mode,
		cacheUnit = unit,
		allowedDigAfterPoint = 1;

	$: if (cacheMode !== mode || cacheUnit !== unit) {
		handleTempRangeInputValidation();
		cacheMode = mode;
		cacheUnit = unit;
	}

	onMount(() => {
		handleTempRangeInputValidation();
	});

	function handleTempRangeInputValidation() {
		if (
			maxTemp.length === 0 ||
			maxTemp === undefined ||
			maxTemp === '' ||
			isNaN(maxTemp)
			// ||
			//check if value is not integer
			// String(maxTemp).indexOf('.') > -1
		) {
			maxError = $format('scene_invalid_format_err_toast');
		} else if (+minTemp >= +maxTemp) {
			maxError = $format('error_min_temp_bellow_min', {
				default: "Max temperature can't be bellow or equal of min temperature",
			});
		} else if (+maxTemp > MAX_TEMPERATURE_LIMIT[unit]) {
			maxError = $format('error_out_of_range', {
				default: `Value ${maxTemp} °${unit} is out of range. Please provide a value within the limits. (${MIN_TEMPERATURE_LIMIT[unit]} °${unit} — ${MAX_TEMPERATURE_LIMIT[unit]} °${unit})`,
				values: {
					value: maxTemp,
					max: MAX_TEMPERATURE_LIMIT[unit],
					min: MIN_TEMPERATURE_LIMIT[unit],
					unit: ` °${unit}`,
				},
			});
		} else {
			maxError = '';
			deftemp = Number(((Number(maxTemp) + Number(minTemp)) / 2).toFixed());
		}

		if (
			minTemp.length === 0 ||
			minTemp === undefined ||
			minTemp === '' ||
			isNaN(minTemp)
			// ||
			//check if value is not integer
			// String(minTemp).indexOf('.') > -1
		) {
			minError = $format('scene_invalid_format_err_toast');
		} else if (+minTemp >= +maxTemp) {
			minError = $format('error_min_temp_above_min', {
				default: "Min temperature can't be above or equal of max temperature",
			});
		} else if (+minTemp < MIN_TEMPERATURE_LIMIT[unit]) {
			minError = $format('error_out_of_range', {
				default: `Value ${+minTemp} °${unit} is out of range. Please provide a value within the limits. (${
					MIN_TEMPERATURE_LIMIT[unit]
				} °${unit} — ${MAX_TEMPERATURE_LIMIT[unit]} °${unit})`,
				values: {
					value: minTemp,
					max: MAX_TEMPERATURE_LIMIT[unit],
					min: MIN_TEMPERATURE_LIMIT[unit],
					unit: ` °${unit}`,
				},
			});
		} else {
			minError = '';
			deftemp = Number(((Number(maxTemp) + Number(minTemp)) / 2).toFixed());
		}
	}

	const dispatch = createEventDispatcher();
	$: if (maxError !== '' || minError !== '') {
		dispatch('error', { maxError, minError });
	} else {
		dispatch('error', { maxError: '', minError: '' });
	}
</script>

<DecreaseIncreaseInput
	icon="fas fa-temperature-arrow-up"
	bind:value={maxTemp}
	bind:error={maxError}
	{allowedDigAfterPoint}
	on:output={(e) => {
		maxTemp = e.detail;
		handleTempRangeInputValidation();
	}}
>
	<div slot="description">
		<slot name="max input description" />
	</div>
</DecreaseIncreaseInput>
<div class="mb-m" />
<DecreaseIncreaseInput
	icon="fas fa-temperature-arrow-down"
	bind:value={minTemp}
	bind:error={minError}
	{allowedDigAfterPoint}
	on:output={(e) => {
		minTemp = e.detail;
		handleTempRangeInputValidation();
	}}
>
	<div slot="description">
		<slot name="min input description" />
	</div>
</DecreaseIncreaseInput>
